import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CompanyType } from 'src/app/settings/constants';

@Component({
  selector: 'app-users-list-component',
  templateUrl: './users-list-component.html',
  styleUrls: ['./users-list-component.scss'],
})
export class UsersListComponent implements OnInit {
  @Input() company: CompanyType;

  displayedColumns: string[] = ['name', 'lastName', 'email', 'role'];
  dataSource: any[];

  show = false;

  constructor() {}

  ngOnInit(): void {
    this.dataSource = this.company.users;
  }

  isLast(item: any, array: string | any[]) {
    return array[array.length - 1] === item;
  }
}
